import React from 'react'
import { IProps } from './index'
import { SupportSpotlightCard } from 'marketing-site/src/library/elements/SupportSpotlightCard'
import { Text } from 'marketing-site/src/library/elements/Text'
import { CTALink } from '../../elements/CTALink'
import { CTATheme, mq } from '../../utils'
import { SupportSpotlightCards } from './SupportSpotlightCards'

export const SupportSpotlight: React.FC<IProps> = ({
  eyebrow,
  mainTitle,
  secondaryTitle,
  featuredCard,
  interactiveCard1,
  interactiveCard2,
  interactiveCard3,
  interactiveCard1StartPosition = 'left',
  cta,
  isVisible,
}) => {
  return (
    <>
      <div className="support-spotlight">
        <div className="support-spotlight__header">
          {eyebrow && (
            <div className="support-spotlight__eyebrow">
              <Text brand="default" size="eyebrows">
                {eyebrow}
              </Text>
            </div>
          )}
          <div className="support-spotlight__main-title">
            <Text brand="default" size="heading-2">
              {mainTitle}
            </Text>
          </div>
          {secondaryTitle && (
            <div className="support-spotlight__secondary-title">
              <Text brand="default" size="heading-4">
                {secondaryTitle}
              </Text>
            </div>
          )}
        </div>
        <div className="support-spotlight__featured-card">
          <SupportSpotlightCard {...featuredCard} isFeaturedCard />
        </div>
        <SupportSpotlightCards
          isVisible={isVisible}
          interactiveCard1={interactiveCard1}
          interactiveCard2={interactiveCard2}
          interactiveCard3={interactiveCard3}
          interactiveCard1StartPosition={interactiveCard1StartPosition}
        />
        {cta && (
          <div className="support-spotlight__cta">
            <CTALink {...cta} bgColor={CTATheme.LinkOnlyBlue} arrow />
          </div>
        )}
      </div>

      <style jsx>{`
        .support-spotlight {
          width: 84.78%;
          max-width: 100vw;
          margin: 0 auto;
          padding-top: 3.281rem;
          padding-bottom: 5.781rem;

          &__featured-card,
          &__header,
          &__cta {
            margin: 0 auto;
          }

          &__header {
            width: 100%;
            max-width: 1042px;
          }

          &__eyebrow,
          &__main-title,
          &__secondary-title {
            text-align: center;
          }

          &__eyebrow + * {
            margin-top: 0.875rem;
          }

          &__main-title + * {
            margin-top: 1rem;
          }

          * + &__featured-card {
            margin-top: 2rem;
          }

          :global(&__featured-card + &__carousel-container) {
            margin-top: 2.25rem;
          }

          :global(&__cards-container + &__cta) {
            margin-top: 2.25rem;
          }

          &__cta {
            margin-top: 2rem;
            text-align: center;
          }
        }

        @media (${mq.tablet}) {
          .support-spotlight {
            &__header + &__featured-card {
              margin-top: 9.75rem;
            }

            :global(&__featured-card + &__cards-container) {
              margin-top: 9.75rem;
            }

            &__cta {
              margin-top: 3.25rem;
            }
          }
        }

        @media (${mq.desktop}) {
          .support-spotlight {
            max-width: $container-max-width;

            &__eyebrow + * {
              margin-top: 1.25rem;
            }

            &__main-title + * {
              margin-top: 1.5rem;
            }

            * + &__featured-card {
              margin-top: 2rem;
            }

            &__header {
              width: 72.06%;
            }
          }
        }
      `}</style>

      <style jsx global>{`
        .support-spotlight {
          .swiper-container {
            overflow: visible;
          }

          .swiper-slide picture,
          .video-player-wrapper {
            -webkit-mask-image: -webkit-radial-gradient(white, black);
            border-radius: 25px;
          }

          .support-card {
            border-radius: 25px;
          }

          // Reverts the scale up secondary effects
          &__cards-container {
            &--first-expanded .support-card__first-card,
            &--second-expanded .support-card__second-card,
            &--third-expanded .support-card__third-card {
              border-radius: 12px;

              .support-spotlight-card__wrapper,
              .video-player-wrapper {
                border-radius: 12px;
              }
            }
          }

          .support-spotlight-card__body--floating {
            transform: translate(-30%, 35%) scale(0.5);
          }
        }

        .switchable-content__view--hide .support-spotlight {
          max-height: 0;
        }

        @media (${mq.desktopLg}) {
          .support-spotlight {
            .support-spotlight-card__body--floating {
              transform: translate(-25%, 25%) scale(0.5);
            }
          }
        }
      `}</style>
    </>
  )
}
